import React from 'react';
import './Services.css';
import { motion } from '../utils/motion';

const Services = () => {
    const services = [
        {
            icon: '🎬',
            title: 'AI Video Creation',
            description: 'Transform concepts into ultra-realistic AI videos with cinematic visual storytelling and generative power.',
            accent: 'linear-gradient(135deg, #6c5ce7, #a29bfe)',
            tag: 'Popular',
            badgeBg: 'rgba(108, 92, 231, 0.2)'
        },
        {
            icon: '🔥',
            title: 'Viral Memes & Culture',
            description: 'Engineering trending meme formats and viral humor designed to trigger mass shares and comments.',
            accent: 'linear-gradient(135deg, #fd79a8, #e17055)',
            tag: 'Trending',
            badgeBg: 'rgba(253, 121, 168, 0.2)'
        },
        {
            icon: '✨',
            title: 'Content & Brand Design',
            description: 'High-end visual branding, thumbnails, and graphic media that elevate your digital aesthetic.',
            accent: 'linear-gradient(135deg, #00cec9, #6c5ce7)',
            tag: null
        },
        {
            icon: '📱',
            title: 'Short-Form Reels & Shorts',
            description: 'Snappy, high-retention video edits optimized for TikTok, Instagram Reels, and YouTube Shorts.',
            accent: 'linear-gradient(135deg, #fdcb6e, #e17055)',
            tag: 'High ROI',
            badgeBg: 'rgba(253, 203, 110, 0.2)'
        },
        {
            icon: '🎨',
            title: 'VFX & Motion Editing',
            description: 'Professional visual FX, dynamic captions, color grading, and seamless transition editing.',
            accent: 'linear-gradient(135deg, #a29bfe, #fd79a8)',
            tag: null
        },
        {
            icon: '🚀',
            title: 'Trend Intelligence & Strategy',
            description: 'Algorithmic insights and data-backed viral strategies to consistently outperform feeds.',
            accent: 'linear-gradient(135deg, #00cec9, #74b9ff)',
            tag: null
        }
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.12 }
        }
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 35 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] }
        }
    };

    return (
        <section className="services" id="services">
            <div className="container">
                {/* Section Header */}
                <motion.div 
                    className="services__header"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8 }}
                >
                    <span className="section-label">What We Master</span>
                    <h2 className="services__title">
                        Crafted to go <span className="gradient-text">viral</span>
                    </h2>
                    <p className="services__subtitle">
                        Comprehensive digital services tailored for modern content creators, brands, and viral media channels.
                    </p>
                </motion.div>

                {/* Services Grid */}
                <motion.div 
                    className="services__grid"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.15 }}
                >
                    {services.map((service, index) => (
                        <motion.div
                            key={index}
                            className={`services__card glass-card ${index === 0 ? 'services__card--featured' : ''}`}
                            variants={cardVariants}
                            whileHover={{ y: -10, scale: 1.03 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                        >
                            <div className="services__card-inner">
                                {service.tag && (
                                    <span className="services__card-tag" style={{ background: service.badgeBg }}>
                                        {service.tag}
                                    </span>
                                )}
                                <div className="services__card-icon" style={{ background: service.accent }}>
                                    <span>{service.icon}</span>
                                </div>
                                <h3 className="services__card-title">{service.title}</h3>
                                <p className="services__card-desc">{service.description}</p>
                                <div className="services__card-arrow">
                                    <span>Explore</span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M3 13L13 3M13 3H5M13 3V11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <div className="services__card-glow" style={{ background: service.accent }} />
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Services;
